(() => {
  'use strict';

  const bg = document.querySelector('.js-bg-current');
  const gsapReady = Boolean(window.gsap && window.ScrollTrigger);
  const splideReady = Boolean(window.Splide);
  const recommendedPlanContainer = document.querySelector('#recommendedplan-home');
  const planSliderElement = document.querySelector('.plan-slider');
  const recommendedPlanApiUrl = 'https://puebloamigo-api.nd-cms.com/api/recommended_plan';
  const recommendedPlanImageUrl = 'https://puebloamigo-content.nd-cms.com/recommended-plan/images/';
  let planSlider = null;

  if (gsapReady) {
    gsap.registerPlugin(ScrollTrigger);
  }

  const sections = gsapReady
    ? gsap.utils.toArray('.js-bg-section')
    : Array.from(document.querySelectorAll('.js-bg-section'));
  const revealItems = gsapReady ? gsap.utils.toArray('.js-reveal') : [];

  const setBackground = (url) => {
    if (!bg || !url || bg.dataset.currentBg === url) {
      return;
    }

    bg.dataset.currentBg = url;
    bg.style.backgroundImage = `url("${url}")`;

    if (gsapReady) {
      gsap.fromTo(
        bg,
        { opacity: 0, scale: 1.07 },
        { opacity: 1, scale: 1.02, duration: 1.1, ease: 'power2.out' }
      );
    } else {
      bg.style.opacity = 1;
    }
  };

  const renderRecommendedPlanMessage = (message) => {
    if (!recommendedPlanContainer) {
      return;
    }

    const noItem = document.createElement('div');
    noItem.className = 'no-item splide__slide';
    noItem.textContent = message;
    recommendedPlanContainer.replaceChildren(noItem);
  };

  const initializePlanSlider = () => {
    if (!splideReady || !planSliderElement) {
      return;
    }

    if (planSlider) {
      planSlider.destroy(true);
    }

    planSlider = new Splide(planSliderElement, {
      type: 'loop',
      autoplay: true,
      start: 0,
      speed: 700,
      perPage: 1,
      perMove: 1,
      gap: '18px',
    });

    const progress = planSliderElement.querySelector('.plan-slider__progress');
    const progressBar = planSliderElement.querySelector('.plan-slider__progress-bar');

    planSlider.on('mounted move autoplay:play', () => {
      if (!progress || !progressBar) {
        return;
      }

      progressBar.style.width = '0%';
      progress.setAttribute('aria-valuenow', '0');
    });

    planSlider.on('autoplay:playing', (rate) => {
      if (!progress || !progressBar) {
        return;
      }

      const percentage = Math.min(Math.max(rate * 100, 0), 100);
      progressBar.style.width = `${percentage}%`;
      progress.setAttribute('aria-valuenow', String(Math.round(percentage)));
    });

    planSlider.mount();
  };

  const createRecommendedPlanHome = (items) => {
    if (!recommendedPlanContainer) {
      return;
    }

    const sourceItems = Array.isArray(items?.data) ? items.data : [];
    const usedRanks = new Set();
    const activeItems = sourceItems.filter((item) => {
      if (Number(item.status) !== 0 || usedRanks.has(String(item.rank))) {
        return false;
      }

      usedRanks.add(String(item.rank));
      return true;
    });

    if (activeItems.length === 0) {
      renderRecommendedPlanMessage('おすすめプランはありません。');
      return;
    }

    const fragment = document.createDocumentFragment();

    activeItems.forEach((item) => {
      const planItem = document.createElement('div');
      const thumbnail = document.createElement('div');
      const image = document.createElement('img');
      const content = document.createElement('div');
      const title = document.createElement('h3');
      const footer = document.createElement('div');
      const link = document.createElement('a');

      planItem.className = 'page-plans__item splide__slide';
      thumbnail.className = 'page-plans__thumbnail';
      image.className = 'page-plans__img';
      image.src = `${recommendedPlanImageUrl}${encodeURIComponent(item.image || '')}`;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      content.className = 'page-plans__content';
      title.className = 'page-plans__heading';
      title.textContent = item.title || '';
      footer.className = 'page-plans__footer';
      link.className = 'page-plans__link';
      link.href = item.link || '#';
      link.textContent = '詳細はこちら';

      thumbnail.append(image);
      content.append(title);
      footer.append(link);
      planItem.append(thumbnail, content, footer);
      fragment.append(planItem);
    });

    recommendedPlanContainer.replaceChildren(fragment);
    initializePlanSlider();
  };

  const loadRecommendedPlans = async () => {
    if (!recommendedPlanContainer) {
      return;
    }

    try {
      const response = await fetch(recommendedPlanApiUrl, {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Recommended plan API returned ${response.status}`);
      }

      createRecommendedPlanHome(await response.json());
    } catch (error) {
      console.error(error);
      renderRecommendedPlanMessage('おすすめプランを取得できませんでした。');
    }
  };

  loadRecommendedPlans();

  if (sections.length > 0) {
    setBackground(sections[0].dataset.bg);

    sections.forEach((section) => {
      const image = new Image();
      image.src = section.dataset.bg;

      if (gsapReady) {
        ScrollTrigger.create({
          trigger: section,
          start: 'top 55%',
          end: 'bottom 45%',
          onEnter: () => setBackground(section.dataset.bg),
          onEnterBack: () => setBackground(section.dataset.bg),
        });
      }
    });
  }

  if (gsapReady) {
    revealItems.forEach((item) => {
      gsap.fromTo(
        item,
        { autoAlpha: 0, y: 32 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: item,
            start: 'top 82%',
            once: true,
          },
        }
      );
    });
  }

  const pageNavLinks = Array.from(document.querySelectorAll('.page-nav__link[href^="#"]'));
  const topScrollPosition = 0;
  const pageNavEntries = pageNavLinks
    .map((link) => ({
      link,
      target: document.querySelector(link.getAttribute('href')),
    }))
    .filter((entry) => entry.target);

  if (pageNavEntries.length > 0) {
    let navUpdatePending = false;

    const updateCurrentNav = () => {
      const currentPosition = window.scrollY;
      let currentSection = sections[0];

      sections.forEach((section) => {
        const sectionPosition = section.getBoundingClientRect().top + window.scrollY;

        if (sectionPosition <= currentPosition) {
          currentSection = section;
        }
      });

      const currentHash = currentSection.id === 'header'
        ? '#top'
        : `#${currentSection.id}`;
      const currentEntry = pageNavEntries.find((entry) => (
        entry.link.getAttribute('href') === currentHash
      ));

      pageNavLinks.forEach((link) => {
        const isCurrent = Boolean(currentEntry && link === currentEntry.link);
        link.classList.toggle('--current', isCurrent);

        if (isCurrent) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      navUpdatePending = false;
    };

    pageNavEntries.forEach(({ link, target }) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const href = link.getAttribute('href');
        const targetPosition = href === '#top'
          ? topScrollPosition
          : target.getBoundingClientRect().top + window.scrollY;

        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });
      });
    });

    const requestNavUpdate = () => {
      if (!navUpdatePending) {
        navUpdatePending = true;
        window.requestAnimationFrame(updateCurrentNav);
      }
    };

    window.addEventListener('scroll', requestNavUpdate, { passive: true });
    window.addEventListener('resize', requestNavUpdate);
    updateCurrentNav();
  }

  if (splideReady) {
    document.querySelectorAll('.lp-slider').forEach((slider) => {
      new Splide(slider, {
        type: 'loop',
        padding: '64px',
        breakpoints: {
          375: {
            padding: '32px',
          },
        },
      }).mount();
    });
  }
})();
